__turbopack_context__.v({
  "text": "ArticleItemTeaserText-module-scss-module__A6SG_q__text",
});
